import React, {useEffect, useMemo, useReducer, useState} from 'react'
import {dbManagerInitialState, dbManagerReducer} from '../../database-manager/reducer/DbManagerReducer'
import {DatabaseManagerService} from 'app/services/database_manager/databaseManagerService'

const BDContext = React.createContext<any>(null)

export const BDProvider: React.FC = ({children}) => {
  const [dbManagerState, dispatch] = useReducer(dbManagerReducer, dbManagerInitialState)
  const [fieldsData, setFieldsData] = useState<any[]>([])

  useEffect(() => {
    const fetchFields = async () => {
      const databaseManagerService = new DatabaseManagerService()
      const response = (await databaseManagerService.getFieldList()).response
      if (response?.status === 200) {
        
        const allowedNameSet = new Set([
          'country',
          'region',
          'list',
          'engagement_level',
          'specialty',
          'status',
        ])

        const filtered = response.data.data.filter((f: any) =>
          allowedNameSet.has((f?.name || '').toLowerCase().trim())
        )
        setFieldsData(filtered)
      }
    }
    fetchFields()
  }, [])

  const value = useMemo(() => ({dbManagerState, dispatch, fieldsData}), [dbManagerState, fieldsData])

  return <BDContext.Provider value={value}>{children}</BDContext.Provider>
}

export default BDContext
